import React from 'react';
import { makeStyles } from 'design-system';
import cx from 'classnames';
import { useProjectInstructionContext } from '../projectInstructionContext';

const ComparisonToggle = () => {
  const { enableDiff, setEnableDiff } = useProjectInstructionContext();
  const classes = useStyles({ checked: enableDiff });

  return (
    <div className={classes.toggleSection}>
      <label className={classes.switch}>
        <input
          type="checkbox"
          checked={enableDiff}
          onChange={e => {
            setEnableDiff(e.target.checked);
          }}
        />
        <span className={cx(classes.slider, { [classes.beforeStyle]: enableDiff })}></span>
      </label>
      <small> Show instructional changes</small>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  toggleSection: {
    padding: '8px 10px',
    borderBottom: `1px solid ${theme.colors.gray05}`,
    display: 'flex',
    alignItems: 'center',
    '& > small': {
      paddingLeft: 10,
    },
  },
  switch: {
    position: 'relative',
    display: 'inline-block',
    width: 30,
    height: 17,
    '& input': {
      opacity: 0,
      width: 0,
      height: 0,
    },
  },

  slider: {
    position: 'absolute',
    cursor: 'pointer',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: ({ checked }: { checked: boolean }) => (checked ? '#2196F3' : '#ccc'),
    '-webkit-transition': '.4s',
    transition: '.4s',
    borderRadius: 17,

    '&:before': {
      position: 'absolute',
      content: '""',
      height: 13,
      width: 13,
      left: 2,
      bottom: 2,
      backgroundColor: 'white',
      '-webkit-transition': '.4s',
      transition: '.4s',
      borderRadius: '50%',
    },
  },
  beforeStyle: {
    '&:before': {
      '-webkit-transform': 'translateX(13px)',
      '-ms-transform': 'translateX(13px)',
      transform: 'translateX(13px)',
    },
  },
}));

export default ComparisonToggle;
